import { httpsCallable } from 'firebase/functions'
import { functions } from '../firebase'

// request/response形式でgptのmessageを取得
export const getGptMessage = httpsCallable(functions, 'get_gpt_message')

// テキストから画像生成
export const getGptImage = httpsCallable(functions, 'get_gpt_image')

// トークンの計算
export const tokenCounter = httpsCallable(functions, 'token_counter')

export const getAzureAIStreamingMessageReaderAndDecoder = async ({ model, messages, temperature = 1, controller }) => {
  let URL = 'https://school-ai-r3y4on4j2a-an.a.run.app/streaming-response-azure'
  if (model === 'azure-gpt-3.5-turbo') {
    // azureの設定で3.5を設定できなかったため、3.5の場合は35に変換
    model = 'azure-gpt-35-turbo'
  }
  try {
    let requestJson = {
      messages,
      model,
      temperature
    }
    const response = await fetch(URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(requestJson),
      signal: controller.signal
    })
    if (!response.ok) {
      const _error = new Error(`HTTP error! Status: ${response.status}`)
      const errorDetail = await response.json().catch(() => null)
      _error.details = errorDetail
      throw _error
    }
    const reader = response.body.getReader()
    const decoder = new TextDecoder('utf-8')
    return [reader, decoder]
  } catch (error) {
    console.error('Error:', error)
    throw error
  }
}
